import { msg } from '@gonfalon/messages/msg';

import { mapToolNameToUserFriendlyToolName } from '../agentInsightsUtils';
import type { ToolClass } from '../components/conversation/activityGrouping';
import { classifyTool } from '../components/conversation/activityGrouping';

const AGENTCORE_OBSERVABILITY_PREFIX = 'observability_';

export const normalizeToolName = (toolName: string) =>
  toolName.startsWith(AGENTCORE_OBSERVABILITY_PREFIX)
    ? `mcp__observability__${toolName.slice(AGENTCORE_OBSERVABILITY_PREFIX.length)}`
    : toolName;

const MCP_TOOL_PREFIX = 'mcp__';

const PLANNING_TOOLS = new Set(['todowrite', 'todoread', 'task']);

const toolClassLabel = (toolClass: ToolClass): string | undefined => {
  switch (toolClass) {
    case 'shell':
      return msg('vega.askVegaProgress.runningCommand');
    case 'search':
      return msg('vega.askVegaProgress.searchingCode');
    case 'files':
      return msg('vega.askVegaProgress.listingFiles');
    case 'read':
      return msg('vega.askVegaProgress.readingFiles');
    case 'write':
      return msg('vega.askVegaProgress.editingFiles');
    case 'skill':
      return msg('vega.askVegaProgress.usingSkill');
    case 'vcs':
      return msg('vega.askVegaProgress.checkingRepository');
    case 'flags':
      return msg('vega.askVegaProgress.checkingFlags');
    case 'db':
      return msg('vega.askVegaProgress.queryingData');
    case 'api':
      return msg('vega.askVegaProgress.fetchingPage');
    case 'other':
    default:
      return undefined;
  }
};

export const toolProgressLabel = (toolName: string) => {
  const name = normalizeToolName(toolName);
  if (name === 'mcp__observability__get_keys') {
    return msg('vega.askVegaProgress.checkingAttributes');
  }
  if (name === 'mcp__observability__get_values') {
    return msg('vega.askVegaProgress.samplingValues');
  }
  const label = mapToolNameToUserFriendlyToolName(name);
  if (label !== name || name.startsWith(MCP_TOOL_PREFIX)) {
    return label;
  }
  if (PLANNING_TOOLS.has(name.toLowerCase())) {
    return msg('vega.askVegaProgress.planning');
  }
  return toolClassLabel(classifyTool({ title: name })) ?? name;
};
